//Please add the language resource
const toxinInspectVehicleArragement = {
  appointmentNo:'预约单号',
  vehicleNo:"车牌号",
  vehicleTypeName:"车型",
  grainOriginName:'粮源地',
  msg:{
    }
};
export default toxinInspectVehicleArragement



// WEBPACK FOOTER //
// ./src/page/toxin/toxinInspectVehicleArragement/lang/toxinInspectVehicleArragement.en.js